<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <producer-list
          v-bubble.error
          v-bubble.info
          @open="$router.push({ name: 'AdminRegistration', params: { id: $event.registrationId } })"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ProducerList from '../components/ProducerList.vue'

export default {
  name: 'AdminProducerListView',

  components: {
    ProducerList
  }
}
</script>
